import { isV3CommsToolName } from '@apps/web/features/phoebe_chat_v3/model/comms_types';
import { type V3ToolEntry } from '@apps/web/features/phoebe_chat_v3/model/transcript';

export type V3ApprovalRoute =
    | 'communications'
    | 'blocked_communications'
    | 'generic'
    | 'none';

function needsApproval(entry: V3ToolEntry): boolean {
    return (
        entry.callId !== null &&
        !entry.isComplete &&
        (entry.approvalState === 'pending' ||
            entry.status === 'pending_approval')
    );
}

/**
 * Chooses exactly one approval surface. Communications never fall through to
 * the generic card because approving one without its recipient and message
 * preview would hide the details the coordinator needs to review.
 */
export function getV3ApprovalRoute(entry: V3ToolEntry): V3ApprovalRoute {
    // The current wait status wins over a stale approval state. This lets the
    // user answer the question that can actually resume the run and prevents
    // communications from exposing a send button at the same time.
    if (entry.status === 'pending_user_input') {
        return 'none';
    }
    if (isV3CommsToolName(entry.name)) {
        if (entry.commsPresentation !== null) {
            return 'communications';
        }
        return needsApproval(entry) ? 'blocked_communications' : 'none';
    }
    if (!needsApproval(entry)) {
        return 'none';
    }
    return 'generic';
}
